module.exports = __webpack_public_path__ + "static/img/pro3_tab3.2ec9c68.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/introduceFour/pro3_tab3.jpg
// module id = 2/aX
// module chunks = 171